import { FC } from "react";
import styles from "./Logo.module.sass";
import { ReactComponent as LogoIcon } from "../../../images/Logo.svg";
import { Link } from "react-router-dom";

export const Logo: FC = () => {
	return (
		<div className={styles["logo-wrp"]}>
			<Link to={`/organizations`} className={styles["logo-link"]}>
				<div>
					<LogoIcon className={styles.logo} />
				</div>
				<div className={styles["logo-titles"]}>
					<span>СИБ</span>
					<span>Филин</span>
				</div>
			</Link>
		</div>
	);
};
